import roles from './roles';

const assignAllowedRoles = {
  SUPER_ADMIN: [
    roles.SUPER_ADMIN,
    roles.ADMIN,
    roles.SUBSCRIBER,
    roles.AFFILIATE,
  ],
  ADMIN: [roles.ADMIN, roles.SUBSCRIBER, roles.AFFILIATE],
  SUBSCRIBER: [roles.SUBSCRIBER, roles.AFFILIATE],
  AFFILIATE: [roles.AFFILIATE],
};

export default assignAllowedRoles;
